import * as React from "react";
import { observer } from "mobx-react-lite";
import { WorkloadDraftMobx } from "../../../mst/stores/workload.draft";
import { NGSwitch } from "../../../newcomponents/switch";
import { NGLabelText } from "../../../newcomponents/text/labelText";
import { NGFormElement } from "../../../newcomponents/ngformelement/ngformelement";

interface Props {
  workloadDraft: WorkloadDraftMobx;
}
const WorkloadCreateRolloutOptionsRaw: React.FC<Props> = ({ workloadDraft }) => {
  const options = workloadDraft.rolloutOptions;

  return (
    <>
      <div className="mb-4">
        <NGSwitch value={options.configure} onChange={options.setConfigure}>
          <NGLabelText>Configure Rollout Options</NGLabelText>
        </NGSwitch>
      </div>
      {options.configure ? (
        <>
          <NGFormElement
            label={options.minReadySeconds.label}
            name={`minReadySeconds`}
            value={options.minReadySeconds.value}
            onChange={options.minReadySeconds.setValue}
          />
          <NGFormElement
            label={options.maxSurgeReplicas.label}
            name={`maxSurgeReplicas`}
            value={options.maxSurgeReplicas.value}
            onChange={options.maxSurgeReplicas.setValue}
          />
          <NGFormElement
            name={"scalingPolicy"}
            as={"select"}
            label={options.scalingPolicy.label}
            options={options.scalingPolicy.options}
            value={options.scalingPolicy.value}
            onChange={options.scalingPolicy.setValue}
          />
          <NGFormElement
            label={options.terminationGracePeriodSeconds.label}
            name={`terminationGracePeriodSeconds`}
            value={options.terminationGracePeriodSeconds.value}
            onChange={options.terminationGracePeriodSeconds.setValue}
          />
          {workloadDraft.isStateful ? null : (
            <NGFormElement
              label={options.maxUnavailableReplicas.label}
              name={`maxUnavailableReplicas`}
              value={options.maxUnavailableReplicas.value}
              onChange={options.maxUnavailableReplicas.setValue}
            />
          )}
        </>
      ) : null}
    </>
  );
};

export const WorkloadCreateRolloutOptions = observer(WorkloadCreateRolloutOptionsRaw);
